import { render } from "./houseCard.vue?vue&type=template&id=6cb3e60e&scoped=true"
import script from "./houseCard.vue?vue&type=script&lang=js"
export * from "./houseCard.vue?vue&type=script&lang=js"

import "./houseCard.vue?vue&type=style&index=0&id=6cb3e60e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6cb3e60e"

export default script